import React, { memo } from "react";
import { Icon } from "@iconify/react";

const PromotionCard = ({
  promotion,
  onClick,
  onSelect,
  getImg,
  makeSvgPlaceholder,
  bonusText,
  depositText,
  disabledSelect,
  isSelected,
}) => (
  <div
    onClick={() => onClick?.(promotion)}
    style={{
      position: "relative",
      background:
        "linear-gradient(180deg, color-mix(in srgb, var(--primaryColor) 14%, rgba(18,18,24,0.98)) 0%, rgba(16,18,24,0.96) 48%, rgba(11,12,18,0.98) 100%)",
      borderRadius: 18,
      overflow: "hidden",
      cursor: "pointer",
      transition: "all 0.3s ease",
      border: isSelected
        ? "1px solid color-mix(in srgb, var(--primaryColor) 78%, white 12%)"
        : "1px solid color-mix(in srgb, var(--primaryColor) 30%, rgba(255,255,255,0.1))",
      boxShadow: isSelected
        ? "0 14px 34px color-mix(in srgb, var(--primaryColor) 34%, transparent), 0 0 0 1px color-mix(in srgb, var(--primaryColor) 40%, transparent) inset"
        : "0 10px 24px rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(255,255,255,0.03) inset",
    }}
    onMouseEnter={(e) => {
      if (!isSelected) {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow =
          "0 16px 34px color-mix(in srgb, var(--primaryColor) 24%, transparent), 0 14px 30px rgba(0, 0, 0, 0.3)";
      }
    }}
    onMouseLeave={(e) => {
      if (!isSelected) {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 10px 24px rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(255,255,255,0.03) inset";
      }
    }}
  >
    {/* Image Section */}
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%",
        background:
          "radial-gradient(circle at top, color-mix(in srgb, var(--primaryColor) 24%, rgba(255,255,255,0.06)) 0%, rgba(18,18,22,0.96) 62%, rgba(10,10,14,0.98) 100%)",
        overflow: "hidden",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }}
      onClick={() => onClick?.(promotion)}
    >
      <img
        src={getImg(promotion, 400, 220)}
        alt={promotion.Detail}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = makeSvgPlaceholder(400, 220);
        }}
      />

      {/* Selected Badge - Top Right */}
      {isSelected && (
        <div
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            width: 40,
            height: 40,
            borderRadius: "50%",
            background:
              "linear-gradient(145deg, var(--primaryColor), color-mix(in srgb, var(--primaryColor) 78%, #000))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow:
              "0 8px 18px color-mix(in srgb, var(--primaryColor) 34%, transparent)",
            zIndex: 10,
          }}
        >
          <Icon
            icon="mdi:check-circle"
            width="28"
            height="28"
            style={{ color: "#fff" }}
          />
        </div>
      )}
    </div>

    {/* Content Section */}
    <div
      style={{
        padding: 16,
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.01) 100%)",
      }}
    >
      <h3
        style={{
          color: isSelected ? "#ffffff" : "#f8fafc",
          fontSize: 18,
          fontWeight: 700,
          marginBottom: 12,
          lineHeight: 1.4,
          textShadow: isSelected
            ? "0 0 14px color-mix(in srgb, var(--primaryColor) 35%, transparent)"
            : "none",
        }}
      >
        {promotion.Detail}
      </h3>

      {/* Badges */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          marginBottom: 4,
        }}
      >
        {depositText(promotion) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 14,
              color: "#e5e7eb",
              background:
                "linear-gradient(135deg, color-mix(in srgb, var(--primaryColor) 12%, rgba(255,255,255,0.04)) 0%, rgba(255,255,255,0.04) 100%)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 12,
              padding: "10px 12px",
            }}
          >
            <Icon
              icon="mdi:cash-plus"
              width="16"
              height="16"
              style={{ color: "var(--primaryColor)", flexShrink: 0 }}
            />
            <span>{depositText(promotion)}</span>
          </div>
        )}
        {bonusText(promotion) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 14,
              color: "#e5e7eb",
              background:
                "linear-gradient(135deg, color-mix(in srgb, var(--primaryColor) 12%, rgba(255,255,255,0.04)) 0%, rgba(255,255,255,0.04) 100%)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 12,
              padding: "10px 12px",
            }}
          >
            <Icon
              icon="mdi:gift-outline"
              width="16"
              height="16"
              style={{ color: "var(--primaryColor)", flexShrink: 0 }}
            />
            <span>{bonusText(promotion)}</span>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default memo(PromotionCard);
